import yousersjs from '@yola/yousersjs';
import { snakeCaseObjectToCamelCase } from 'src/js/utils/convert-case';
import setPartnerData from '../actions/set-partner-data';
import savePartnerId from '../helpers/save-partner-id';

const fetchPartnerData = (partnerId, locale) => async (dispatch) => {
  try {
    const response = await yousersjs.partner().getById(partnerId, {
      propertiesLocale: locale,
    });

    const data = snakeCaseObjectToCamelCase(response.body);
    savePartnerId(partnerId);

    dispatch(setPartnerData(data));
  } catch (e) {
    console.error(e);
  }
};

export default fetchPartnerData;
